export const environment = {
  production: true,
  bffUrl: 'api/v2',
};
